module.exports = __webpack_public_path__ + "img/bill-glyph-16.dcdb46af.svg";